<script setup lang="ts">
import type { ArticleSize, ContentArticle } from '~/models/Content/ContentArticle'

const { item, size } = defineProps<{
  item: ContentArticle
  size: ArticleSize
}>()
</script>

<template>
  <section class="col-[media] flex items-start gap-4 font-semibold text-(--theme-60)">
    <h2
      class="grid aspect-square size-[5ch] place-items-center rounded-full bg-(--theme-pop) uppercase"
      :class="{ 'au-subtitle': size !== 'xlarge' }"
    >
      {{ $t('article.word') }}:
    </h2>
    <ul class="flex flex-wrap gap-4 self-center">
      <li
        v-for="word in item.wordlist"
        :key="word"
        class="rounded-md bg-(--theme-pop) px-3 py-1"
      >
        {{ word }}
      </li>
    </ul>
  </section>
</template>
